export const SELECTOR_ORDER_SELECTED = (state) => state.orders.orderSelected;

export const SELECTOR_ORDERS_TOTALS = (state) => state.orders.ordersTotals;

export const SELECTOR_ORDERS_CURRENT = (state) =>
  state.orders.orders[state.orders.orderSelected];

export const SELECTOR_ORDERS = (state) => Object.values(state.orders.orders);

export const SELECTOR_OTHERS_ORDER_SELECTED = (state) =>
  state.orders.othersOrderSelected;

export const SELECTOR_OTHERS_ORDERS_TOTALS = (state) =>
  state.orders.othersOrdersTotals;

export const SELECTOR_OTHERS_ORDERS_CURRENT = (state) =>
  state.orders.othersOrders[state.orders.othersOrderSelected];

export const SELECTOR_OTHERS_ORDERS = (state) =>
  Object.values(state.orders.othersOrders);
